import { render, staticRenderFns } from "./rdinfo.vue?vue&type=template&id=1ecca93a&scoped=true&"
import script from "./rdinfo.vue?vue&type=script&lang=js&"
export * from "./rdinfo.vue?vue&type=script&lang=js&"
import style0 from "./rdinfo.vue?vue&type=style&index=0&id=1ecca93a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecca93a",
  null
  
)

export default component.exports